import { render, staticRenderFns } from "./listFive.vue?vue&type=template&id=10bad99b&scoped=true"
import script from "./listFive.vue?vue&type=script&lang=js"
export * from "./listFive.vue?vue&type=script&lang=js"
import style0 from "./listFive.vue?vue&type=style&index=0&id=10bad99b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bad99b",
  null
  
)

export default component.exports